// extracted by mini-css-extract-plugin
export default {"Col4":"ComInterView_Col4__N5i-Z"};